var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "popup-section popup-follow"
  }, [_c('div', {
    staticClass: "popup-mask",
    on: {
      "click": function click($event) {
        return _vm.clickClosePop();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-container"
  }, [_c('div', {
    staticClass: "popup-title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("Following")))])]), _vm._v(" "), _c('div', {
    staticClass: "popup-close",
    on: {
      "click": function click($event) {
        return _vm.clickClosePop();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-box",
    attrs: {
      "data-type": "followPop"
    }
  }, [_vm.followingList.length > 0 ? _c('ul', _vm._l(_vm.followingList, function (following, index) {
    return _c('li', {
      key: index,
      staticClass: "popup-item"
    }, [_c('a', {
      attrs: {
        "href": _vm.goPersonalLink(following.uid)
      }
    }, [following.face ? _c('div', {
      staticClass: "headimage",
      style: {
        backgroundImage: 'url(' + following.face + ')'
      }
    }) : _c('div', {
      staticClass: "headimage"
    })]), _vm._v(" "), _c('div', {
      staticClass: "popup-info"
    }, [_c('a', {
      attrs: {
        "href": _vm.goPersonalLink(following.uid)
      }
    }, [_c('div', {
      staticClass: "nickname"
    }, [_vm._v(_vm._s(following.nickname))])]), _vm._v(" "), _c('div', {
      staticClass: "usign"
    }, [_vm._v(_vm._s(following.usign))])]), _vm._v(" "), following.ship == '0' ? _c('div', {
      staticClass: "follow-fn follow",
      on: {
        "click": function click($event) {
          return _vm.clickFollowFriend(following.uid, 'followPop', index);
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t("Follow")) + "\n                    ")]) : _c('div', {
      staticClass: "follow-fn following"
    }, [_vm._v(_vm._s(_vm.$t("Following")))])]);
  }), 0) : _c('div', {
    staticClass: "no_data"
  }, [_vm._v(_vm._s(_vm.$t("noData")))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.followAndFansNoMoreData,
      expression: "followAndFansNoMoreData"
    }],
    staticClass: "no_more_data"
  }, [_vm._v(_vm._s(_vm.$t("noMoreData")))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.followAndFansLoading,
      expression: "followAndFansLoading"
    }],
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "spinner"
  })])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };